import { type ComponentType, type FC } from 'react';
import { type ResponsiveContextModalProps } from '~/shared/ui/ResponsiveModals';

export const withResponsiveModalProps = <P extends object>(
    Component: ComponentType<P>,
): FC<ResponsiveContextModalProps<P>> => {
    return ({ innerProps }: ResponsiveContextModalProps<P>) => {
        return <Component {...innerProps} />;
    };
};
